"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function watchNavigatorLocation(cb) {
    if ('geolocation' in navigator) {
        var id_1 = navigator.geolocation.watchPosition(function (position) {
            if (position.coords.longitude && position.coords.latitude) {
                cb({
                    lng: position.coords.longitude,
                    lat: position.coords.latitude,
                });
            }
        });
        return function () { return navigator.geolocation.clearWatch(id_1); };
    }
    return function () {
        // EMPTY UNSUBSCRIBE
    };
}
exports.watchNavigatorLocation = watchNavigatorLocation;
function getNavigatorLocation() {
    return new Promise(function (res) {
        if ('geolocation' in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                if (position.coords.longitude && position.coords.latitude) {
                    res({
                        lng: position.coords.longitude,
                        lat: position.coords.latitude,
                    });
                }
                else {
                    res(null);
                }
            }, function () { return res(null); });
        }
        else {
            res(null);
        }
    });
}
exports.getNavigatorLocation = getNavigatorLocation;
//# sourceMappingURL=navigator.js.map